export default {
    state() {
        return {
            measures: []
        }
    },
    mutations: {
        setMeasures(state, payload) {
            state.measures = payload
        },
        addMeasure(state, payload) {
            state.measures.push(payload);
        }
    }
};
